export default __webpack_public_path__ + "9c9e7c7.png";